import { useContext, useEffect } from "react";
import { DiffParams, SalesMeasure } from "../diff_params";
import { PeriodType } from "../period_type";
import { PlanningReviewControlComponent } from "./component";
import { RunTriggerContext } from "../../../../contexts/run_trigger/context";

export const PlanningReviewControlContainer = (props: {
  diffParams: DiffParams;
  updateDiffParams: (params: DiffParams) => void;
}) => {
  const { diffParams, updateDiffParams } = props;
  const { runLogs, isLogsLoading } = useContext(RunTriggerContext);

  const updateParams = (params: DiffParams) => {
    updateDiffParams({
      ...params,
      salesMeasure: params.salesMeasure || SalesMeasure.QUANTITY,
    });
  };

  const updateRuns = (params: DiffParams) => {
    const runLog0 = runLogs.find(
      (rl) => params.runId0 === (rl.id === null ? "" : `${rl.id}`)
    );
    const runLog1 = runLogs.find(
      (rl) => params.runId1 === (rl.id === null ? "" : `${rl.id}`)
    );
    updateDiffParams({
      ...params,
      ...(params.runId0 !== null &&
        params.runId1 === null && {
          minDate: runLog0?.startedAt ? new Date(runLog0?.startedAt) : null,
          maxDate: runLog0?.startedAt
            ? new Date(
                new Date(runLog0.startedAt || "1970-01-01").getUTCFullYear(),
                11,
                31
              )
            : null,
        }),
      ...(params.runId0 !== null &&
        params.runId1 !== null && {
          minDate: runLog1?.startedAt ? new Date(runLog1?.startedAt) : null,
          // NOTE: we don't have the run1 data yet, and for that reason the
          // maxDate is unknown yet. Setting the maxDate to null, and
          // setting it later with a useEffect.
          maxDate: new Date(
            Math.min(
              new Date(
                runLog0?.orderSimulationEndDate || "2024-06-30"
              ).getTime(),
              new Date(
                runLog1?.orderSimulationEndDate || "2024-06-30"
              ).getTime()
            )
          ),
          heatMap: params.heatMap === null ? true : params.heatMap,
        }),
      aggregatePeriodType: PeriodType.MONTH,
      salesMeasure: params.salesMeasure || SalesMeasure.QUANTITY,
    });
  };

  useEffect(() => {
    if (
      diffParams.maxDate === null &&
      diffParams.runId0 !== null &&
      diffParams.runId1 !== null
    ) {
      const runLog0 = runLogs.find(
        (rl) => diffParams.runId0 === (rl.id === null ? "" : `${rl.id}`)
      );
      const runLog1 = runLogs.find(
        (rl) => diffParams.runId1 === (rl.id === null ? "" : `${rl.id}`)
      );
      updateDiffParams({
        ...diffParams,
        maxDate: new Date(
          Math.min(
            new Date(runLog0?.orderSimulationEndDate || "2024-06-30").getTime(),
            new Date(runLog1?.orderSimulationEndDate || "2024-06-30").getTime()
          )
        ),
      });
    }
  }, [diffParams, runLogs, updateDiffParams]);

  const excelExport = () => {};

  return (
    <PlanningReviewControlComponent
      diffParams={diffParams}
      updateDiffParams={updateParams}
      updateRuns={updateRuns}
      loading={isLogsLoading}
      error={null}
      excelExport={excelExport}
    />
  );
};
